import { FC } from 'react';
import { Colors } from 'melp-design/style';
import { Box } from '@mui/material';
import { APP } from 'config';
import { getBorder } from '../../../constants/Style';

interface Props {
  visible?: boolean;
}

export const FOOTER_ID = 'app-footer';
export const FOOTER_HEIGHT = 70;

export const Footer: FC<Props> = ({ visible = true, children }) => {
  if (!visible) return null;

  return (
    <Box
      id={FOOTER_ID}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: FOOTER_HEIGHT,
        backgroundColor: 'white',
        borderTop: getBorder(Colors.elementsGrey),
        padding: '5px 0',
        zIndex: 1,
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <Box
        sx={(theme) => ({
          width: '100%',
          maxWidth: APP.layout.container.maxWidth,

          [theme.breakpoints.down('lg')]: {
            padding: '0 65px',
          },
        })}
      >
        {children}
      </Box>
    </Box>
  );
};
